import React from "react";
import ProductPrice from "../ProductPrice/ProductPrice";
import {T} from '../../../utils/I18n/I18n';
import readConfig from '../../../utils/readClientConfiguration';
import productionConfiguration from '../../../config/default.json';
import hidePriceSkus from '../../../utils/hidePriceSkus';

const baseClassName = 'product-item';

const countryCode = readConfig(productionConfiguration, 'countryCode');
const isRs = countryCode.includes('RS');

const PriceBlock = ({product, hideLast30 = false, hideLabels = false, shortLabel=false}) => {

    const prices=product?.prices ?? [];
    const shouldHidePrice = hidePriceSkus.includes(product.sku);

    switch (product.__typename) {
        case "GroupedProduct":
            return (
                <div className="product-item__price-box">
                    <div className="product-price__price price"><T id="product.pricePerElements"/></div>
                </div>
            )
            break;
    }
    const hasPromoPrice = prices.filter((price) => {
        return ['simple_loyalty'].includes(price.price_type);
    }).length > 0;

    const hasDiscount = prices.filter((price) => {
        return ['simple_clearance', 'promo_price', 'simple_promo'].includes(price.price_type);
    }).length > 0;

    return (
        <div className={
            [
                `${baseClassName}__price-box`,
                hasPromoPrice ? 'hasPromoPrice' : '',
                hasDiscount ? 'hasDiscount' : '',
            ].join(' ')}>
            {prices.map((price, index) => {
                return (
                    <ProductPrice price={price} key={index} hideLabels={hideLabels} hidePrice={shouldHidePrice} shortLabel={shortLabel}/>
                )
            })}
        </div>
    )
}

export default PriceBlock